export const scrollChatContainerToBottom = (container: HTMLElement): void => {
  container.scrollTop = container.scrollHeight;
};
